import { SpinnerHelper, SpinnerArgs } from "./spinner-helper";

export interface IResponse {
	requestError: boolean;
	error?: any;
	code?: number;
	headers?: Headers;
}

export interface IResponseWithData<T> extends  IResponse {
	data?: T;
}

export class RequestHelper {

	public static async postJsonAndSpin<TResponse>(url: string, data: any, includeCredentials = false, spinnerArgs?: SpinnerArgs) {
		return await SpinnerHelper.spinAndDeactivateWhile(RequestHelper.postJson(url, data, includeCredentials), spinnerArgs);
	}

	public static async postJson<TResponse>(url: string, data: any, includeCredentials = false): Promise<IResponseWithData<TResponse>> {
		var init: RequestInit = {
			method: "POST",
			headers: {
				'Accept': "application/json",
				'Content-Type': "application/json"
			},
			credentials: includeCredentials ? "include" : "omit",
			body: JSON.stringify(data)
		};

		try {
			const response = await fetch(url, init);
			return {
				requestError: false,
				code: response.status,
				data: await response.json(),
				headers: response.headers
			}
		} catch (exception) {
			return {
				requestError: true,
				error: exception
			}
		}
	}

	public static async getBlob(url: string, includeCredentials = false): Promise<IResponseWithData<Blob>> {
		var init: RequestInit = {
			method: "GET",
			credentials: includeCredentials ? "include" : "omit"
		};

		try {
			const response = await fetch(url, init);
			return {
				requestError: false,
				code: response.status,
				data: await response.blob(),
				headers: response.headers
			}
		} catch (exception) {
			return {
				requestError: true,
				error: exception
			}
		}
	}
}